import {
    LOGIN,
    LOGOUT,
    ACCOUNT_INITIALIZE,
    REFRESH_TOKEN,
    CHANGE_CHANNEL,
    CHANGE_ISSUER,
    INITIALIZE_CHANNELS
} from './accountActions';

export const initialState = {
    token: '',
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    language: { languageId: 1 },
    channels: [],
    channel: {},
    issuer: {},
};

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACCOUNT_INITIALIZE: {
            // Only merge fields that are explicitly present in the payload.
            //
            // ACCOUNT_INITIALIZE is dispatched by two callers with different payloads:
            //   1. authInitialize (login)     — full payload: isLoggedIn, user, token, language
            //   2. accountInitialize (static) — language-only: { language, settings }
            //
            // Without this guard, caller 2 would destructure isLoggedIn/user/token as
            // undefined and overwrite the existing authenticated state, effectively
            // logging the user out during the startup language-initialization step.
            const { isLoggedIn, user, token, language } = action.payload;
            return {
                ...state,
                isInitialized: true,
                ...(language    !== undefined && { language }),
                ...(isLoggedIn  !== undefined && { isLoggedIn }),
                ...(token       !== undefined && { token }),
                ...(user        !== undefined && { user }),
            };
        }
        case LOGIN: {
            const { user, token } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                token,
                user
            };
        }
        case REFRESH_TOKEN: {
            const { token } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                token
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
                token: '',
                user: null
            };
        }
        case CHANGE_CHANNEL: {
            const { channelId } = action.payload;
            return {
                ...state,
                channel: { channelId },
            };
        }
        case INITIALIZE_CHANNELS: {
            const channels = action.payload;
            return {
                ...state,
                channels: channels,
            };
        }
        case CHANGE_ISSUER: {
            const { issuerId } = action.payload;
            return {
                ...state,
                issuer: { issuerId },
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
